exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt-10[data-v-2b8718ce] {\n  margin-bottom: 10px;\n}\n.mb-10[data-v-2b8718ce] {\n  margin-bottom: 10px;\n}\n.mb-20[data-v-2b8718ce] {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
